const CHUNK_ERRORS = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Importing a module script failed",
  "Unable to preload CSS",
];

const RELOADED_AT = "ats.chunkReloadAt";
const RELOAD_WINDOW_MS = 30_000;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERRORS.some((m) => error.message.includes(m));
}

// Browsers cache a failed module import for the life of the document, so only a reload can fetch the chunk again.
export function reloadOnceForChunkError(reload: () => void = () => window.location.reload(), now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOADED_AT));
    if (last && now - last < RELOAD_WINDOW_MS) return false;
    sessionStorage.setItem(RELOADED_AT, String(now));
  } catch {
    return false;
  }
  reload();
  return true;
}
